import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import { styles, guideMargin } from './guides.styles'
import Guide from './guide/guide.jsx'

const GUIDES_SIZES = {
  large: 3,
  medium: 4,
  narrow: 5
}

const Guides = ({ classes, lineHeight }) => {
  const n = GUIDES_SIZES[lineHeight]
  return (
    <Fragment>
      {Array.from(Array(n).keys()).map((el, i) => (
        <Guide
          key={i}
          style={{
            height: `calc((100% - (${guideMargin} * ${n - 1})) / ${n})`
          }}
          className={classes.guide}
        />
      ))}
    </Fragment>
  )
}

export default injectSheet(styles)(Guides)
